module.exports = __webpack_public_path__ + "img/emoji_82.57e9a6ec.png";